import { HttpClient } from '@/components/shared/security/http-client'

export const ShoppingCartService = {

  async createShoppingCart (accountIdentifier) {
    try {
      await HttpClient.post('api/shopping-carts', null, { params: { accountIdentifier } })
    } catch (error) {
      console.error('Failed to create shopping cart', error)
    }
  },

  async getActiveShoppingCart (createCartForAccountIdentifier) {
    try {
      return await HttpClient.get('api/shopping-carts/active', { params: { createCartForAccountIdentifier } })
    } catch (error) {
      console.error('Failed to get active shopping cart', error)
    }

    return null
  },

  async updateCart (cartId, accountIdentifier, updateUploadRequest) {
    try {
      await HttpClient.patch(`api/shopping-carts/${cartId}?accountIdentifier=${accountIdentifier}`, updateUploadRequest)
    } catch (error) {
      console.error('Failed to update cart', error)
    }
  },

  async updateLegacyLineItem (cartId, legacyIdentifier, updateLineItemRequest) {
    try {
      await HttpClient.patch(`api/shopping-carts/${cartId}/line-items/by-legacy-upload-identifier/${legacyIdentifier}`, updateLineItemRequest)
    } catch (error) {
      console.error('Failed to update legacy line item', error)
    }
  },

  async deleteLegacyLineItem (cartId, legacyIdentifier) {
    try {
      return await HttpClient.delete(`api/shopping-carts/${cartId}/line-items/by-legacy-upload-identifier/${legacyIdentifier}`)
    } catch (error) {
      console.error('Failed to delete legacy line item', error)
    }
  },

  async deleteLineItemsByFulfillmentType (cartId, fulfillmentType) {
    try {
      await HttpClient.delete(`api/shopping-carts/${cartId}/line-items/fulfillment-type/${fulfillmentType}`)
    } catch (error) {
      console.error('Failed to delete line items by fulfillment type', error)
    }
  }
}
